export const generatedSidecarRunSpecPacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-sidecar-run-spec-packet",
  "operatingRule": "Run specifications define how external science workers must be executed and reviewed; they do not promote science claims without runtime intake reports.",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "workOrderPacketHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
  "specCount": 5,
  "blockedRuntimeSpecCount": 5,
  "evidenceBoundary": "Run specs are reproducibility instructions. Only generated sidecar artifacts and reviewed intake reports can become model evidence.",
  "runSpecs": [
    {
      "id": "run-spec-spice-gf-event-window-v1",
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "runState": "spec-only-not-runtime-evidence",
      "claimState": "not-evidence-until-runtime-intake-promotes",
      "executionHost": "science-sidecar-python",
      "workerRuntime": "python-cspice-or-spiceypy",
      "installEvidence": [
        "SPICE Toolkit or SpiceyPy version",
        "kernel manifest checksums"
      ],
      "sourceRefs": [
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "organization": "NASA NAIF",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
          "trust": "primary",
          "recordHash": "fnv1a32-97d74c96",
          "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
          "uncertaintyMode": "Kernel coverage plus geometric tolerance."
        }
      ],
      "requiredInputs": [
        {
          "id": "scenario-record",
          "required": true,
          "evidence": "scenarioId must resolve to a versioned model-run or scenario notebook record."
        },
        {
          "id": "source-snapshot-records",
          "required": true,
          "evidence": "All sourceIds must map to reviewed source payloads or explicit blocked source gaps."
        },
        {
          "id": "units-and-time-scale",
          "required": true,
          "evidence": "Units and time scale must be declared in the output artifact."
        },
        {
          "id": "spice-kernel-manifest",
          "required": true,
          "evidence": "SPK/PCK/LSK/meta-kernel file names, coverage, and sha256 hashes."
        },
        {
          "id": "geometry-finder-constraints",
          "required": true,
          "evidence": "Target, observer, aberration correction, confinement window, step size, and GF condition."
        }
      ],
      "outputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
      "outputContract": {
        "requiredFields": [
          "toolVersion",
          "runAt",
          "scenarioId",
          "kernelSet",
          "kernelHashes",
          "timeScale",
          "gfConstraint",
          "eventWindows",
          "units",
          "uncertainty",
          "reproducibleCommand",
          "inputsHash",
          "outputsHash",
          "checksums",
          "limitations",
          "validationStatus"
        ],
        "sourceIds": [
          "spice-gf"
        ],
        "promotionRule": "SPICE event windows can promote only when kernel hashes, time scale, GF constraints, generated windows, and checksum evidence are attached."
      },
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "SPICE kernel coverage, TDB/ET time key, confinement window, GF constraint, and event-window endpoints are recorded."
      ],
      "failureModes": [
        "Missing source payload review.",
        "Missing reproducible command or environment lock.",
        "Hash drift between generated output and submitted intake artifact.",
        "Units, time scale, or frame not declared.",
        "Kernel coverage does not span the requested confinement window."
      ],
      "reviewChecklist": [
        "Confirm the source payload hashes are current for the run.",
        "Confirm the worker environment and input manifests are hash-backed.",
        "Run the command exactly as recorded or record the exact deviation.",
        "Validate the output artifact with the sidecar intake CLI.",
        "Do not update verified claims until the intake report is reviewed."
      ],
      "promotionBoundary": "This run spec is an execution contract only. It is not a scientific result, runtime artifact, or customer-facing proof.",
      "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c"
    },
    {
      "id": "run-spec-orekit-propagation-v1",
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "runState": "spec-only-not-runtime-evidence",
      "claimState": "not-evidence-until-runtime-intake-promotes",
      "executionHost": "science-sidecar-jvm",
      "workerRuntime": "java-orekit",
      "installEvidence": [
        "Orekit version",
        "orekit-data archive hash",
        "JVM version"
      ],
      "sourceRefs": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "organization": "CS Group / open source community",
          "url": "https://www.orekit.org/",
          "trust": "open-source",
          "recordHash": "fnv1a32-88a8d672",
          "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
          "uncertaintyMode": "Model configuration and independent comparison residuals."
        }
      ],
      "requiredInputs": [
        {
          "id": "scenario-record",
          "required": true,
          "evidence": "scenarioId must resolve to a versioned model-run or scenario notebook record."
        },
        {
          "id": "source-snapshot-records",
          "required": true,
          "evidence": "All sourceIds must map to reviewed source payloads or explicit blocked source gaps."
        },
        {
          "id": "units-and-time-scale",
          "required": true,
          "evidence": "Units and time scale must be declared in the output artifact."
        },
        {
          "id": "orekit-data-context",
          "required": true,
          "evidence": "orekit-data archive hash, frames, time scales, EOP/IERS conventions where used."
        },
        {
          "id": "force-model-definition",
          "required": true,
          "evidence": "Gravity, SRP, third-body, atmosphere, and event detector settings."
        }
      ],
      "outputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
      "outputContract": {
        "requiredFields": [
          "toolVersion",
          "runAt",
          "scenarioId",
          "dataContext",
          "frames",
          "timeScale",
          "forceModel",
          "events",
          "units",
          "uncertainty",
          "reproducibleCommand",
          "inputsHash",
          "outputsHash",
          "checksums",
          "independentComparison",
          "limitations",
          "validationStatus"
        ],
        "sourceIds": [
          "orekit"
        ],
        "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      },
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "failureModes": [
        "Missing source payload review.",
        "Missing reproducible command or environment lock.",
        "Hash drift between generated output and submitted intake artifact.",
        "Units, time scale, or frame not declared.",
        "Independent comparison missing, failed, or lacks residual bounds."
      ],
      "reviewChecklist": [
        "Confirm the source payload hashes are current for the run.",
        "Confirm the worker environment and input manifests are hash-backed.",
        "Run the command exactly as recorded or record the exact deviation.",
        "Validate the output artifact with the sidecar intake CLI.",
        "Do not update verified claims until the intake report is reviewed."
      ],
      "promotionBoundary": "This run spec is an execution contract only. It is not a scientific result, runtime artifact, or customer-facing proof.",
      "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd"
    },
    {
      "id": "run-spec-gmat-transfer-v1",
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "runState": "spec-only-not-runtime-evidence",
      "claimState": "not-evidence-until-runtime-intake-promotes",
      "executionHost": "science-sidecar-native",
      "workerRuntime": "native-gmat-cli",
      "installEvidence": [
        "GMAT version",
        "GMAT script hash",
        "platform and executable hash"
      ],
      "sourceRefs": [
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "organization": "NASA",
          "url": "https://software.nasa.gov/software/GSC-17177-1",
          "trust": "primary",
          "recordHash": "fnv1a32-3743e565",
          "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
          "uncertaintyMode": "Constraint residuals and cross-tool comparison."
        }
      ],
      "requiredInputs": [
        {
          "id": "scenario-record",
          "required": true,
          "evidence": "scenarioId must resolve to a versioned model-run or scenario notebook record."
        },
        {
          "id": "source-snapshot-records",
          "required": true,
          "evidence": "All sourceIds must map to reviewed source payloads or explicit blocked source gaps."
        },
        {
          "id": "units-and-time-scale",
          "required": true,
          "evidence": "Units and time scale must be declared in the output artifact."
        },
        {
          "id": "gmat-script",
          "required": true,
          "evidence": "Hashed GMAT script plus resources, propagator, optimizer, constraints, and report outputs."
        },
        {
          "id": "mission-design-constraints",
          "required": true,
          "evidence": "Epoch, launch/arrival body definitions, burns, bounds, and residual tolerances."
        }
      ],
      "outputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "outputContract": {
        "requiredFields": [
          "gmatVersion",
          "runAt",
          "scenarioId",
          "scriptHash",
          "epoch",
          "forceModel",
          "optimizer",
          "trajectorySummary",
          "constraintSummary",
          "units",
          "uncertainty",
          "reproducibleCommand",
          "inputsHash",
          "outputsHash",
          "checksums",
          "independentComparison",
          "limitations",
          "validationStatus"
        ],
        "sourceIds": [
          "gmat"
        ],
        "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      },
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "failureModes": [
        "Missing source payload review.",
        "Missing reproducible command or environment lock.",
        "Hash drift between generated output and submitted intake artifact.",
        "Units, time scale, or frame not declared.",
        "Independent comparison missing, failed, or lacks residual bounds."
      ],
      "reviewChecklist": [
        "Confirm the source payload hashes are current for the run.",
        "Confirm the worker environment and input manifests are hash-backed.",
        "Run the command exactly as recorded or record the exact deviation.",
        "Validate the output artifact with the sidecar intake CLI.",
        "Do not update verified claims until the intake report is reviewed."
      ],
      "promotionBoundary": "This run spec is an execution contract only. It is not a scientific result, runtime artifact, or customer-facing proof.",
      "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8"
    },
    {
      "id": "run-spec-tudat-transfer-v1",
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "runState": "spec-only-not-runtime-evidence",
      "claimState": "not-evidence-until-runtime-intake-promotes",
      "executionHost": "science-sidecar-python",
      "workerRuntime": "python-tudatpy",
      "installEvidence": [
        "TudatPy version",
        "Python environment lock hash",
        "SPICE/body settings hashes"
      ],
      "sourceRefs": [
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "organization": "TU Delft Astrodynamics Toolbox community",
          "url": "https://docs.tudat.space/en/latest/",
          "trust": "open-source",
          "recordHash": "fnv1a32-c238f1d2",
          "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
          "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds."
        }
      ],
      "requiredInputs": [
        {
          "id": "scenario-record",
          "required": true,
          "evidence": "scenarioId must resolve to a versioned model-run or scenario notebook record."
        },
        {
          "id": "source-snapshot-records",
          "required": true,
          "evidence": "All sourceIds must map to reviewed source payloads or explicit blocked source gaps."
        },
        {
          "id": "units-and-time-scale",
          "required": true,
          "evidence": "Units and time scale must be declared in the output artifact."
        },
        {
          "id": "tudat-body-settings",
          "required": true,
          "evidence": "Body settings, ephemerides, central bodies, propagator, integrator, and termination rules."
        },
        {
          "id": "cross-tool-reference",
          "required": true,
          "evidence": "Orekit or GMAT artifact id used for disagreement/residual comparison."
        }
      ],
      "outputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "outputContract": {
        "requiredFields": [
          "toolVersion",
          "runAt",
          "scenarioId",
          "bodySettings",
          "integrator",
          "propagatorSettings",
          "trajectorySummary",
          "residualSummary",
          "units",
          "uncertainty",
          "reproducibleCommand",
          "inputsHash",
          "outputsHash",
          "checksums",
          "independentComparison",
          "limitations",
          "validationStatus"
        ],
        "sourceIds": [
          "tudat"
        ],
        "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      },
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "failureModes": [
        "Missing source payload review.",
        "Missing reproducible command or environment lock.",
        "Hash drift between generated output and submitted intake artifact.",
        "Units, time scale, or frame not declared.",
        "Independent comparison missing, failed, or lacks residual bounds."
      ],
      "reviewChecklist": [
        "Confirm the source payload hashes are current for the run.",
        "Confirm the worker environment and input manifests are hash-backed.",
        "Run the command exactly as recorded or record the exact deviation.",
        "Validate the output artifact with the sidecar intake CLI.",
        "Do not update verified claims until the intake report is reviewed."
      ],
      "promotionBoundary": "This run spec is an execution contract only. It is not a scientific result, runtime artifact, or customer-facing proof.",
      "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39"
    },
    {
      "id": "run-spec-openmdao-dymos-optimization-v1",
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "runState": "spec-only-not-runtime-evidence",
      "claimState": "not-evidence-until-runtime-intake-promotes",
      "executionHost": "science-sidecar-python",
      "workerRuntime": "python-openmdao-dymos",
      "installEvidence": [
        "OpenMDAO version",
        "Dymos version",
        "optimizer package and seed"
      ],
      "sourceRefs": [
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "organization": "NASA",
          "url": "https://openmdao.org/",
          "trust": "primary",
          "recordHash": "fnv1a32-9ef7d3cb",
          "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
          "uncertaintyMode": "Sensitivity and optimizer-convergence metadata."
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "organization": "OpenMDAO project",
          "url": "https://openmdao.github.io/dymos/",
          "trust": "open-source",
          "recordHash": "fnv1a32-31dbd31c",
          "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
          "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals."
        }
      ],
      "requiredInputs": [
        {
          "id": "scenario-record",
          "required": true,
          "evidence": "scenarioId must resolve to a versioned model-run or scenario notebook record."
        },
        {
          "id": "source-snapshot-records",
          "required": true,
          "evidence": "All sourceIds must map to reviewed source payloads or explicit blocked source gaps."
        },
        {
          "id": "units-and-time-scale",
          "required": true,
          "evidence": "Units and time scale must be declared in the output artifact."
        },
        {
          "id": "optimization-problem",
          "required": true,
          "evidence": "Objective, constraints, transcription metadata, optimizer, design variables, and deterministic problem hash."
        },
        {
          "id": "sensitivity-plan",
          "required": true,
          "evidence": "Driver variables, perturbation ranges, convergence criteria, and reported Pareto slices."
        }
      ],
      "outputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "outputContract": {
        "requiredFields": [
          "toolVersion",
          "runAt",
          "scenarioId",
          "problemHash",
          "transcription",
          "optimizer",
          "objective",
          "constraints",
          "sensitivitySummary",
          "units",
          "uncertainty",
          "reproducibleCommand",
          "inputsHash",
          "outputsHash",
          "checksums",
          "independentComparison",
          "limitations",
          "validationStatus"
        ],
        "sourceIds": [
          "openmdao",
          "dymos"
        ],
        "promotionRule": "Optimization outputs can influence recommendations only when objective, constraints, sensitivities, and reproducible run artifacts are attached."
      },
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "failureModes": [
        "Missing source payload review.",
        "Missing reproducible command or environment lock.",
        "Hash drift between generated output and submitted intake artifact.",
        "Units, time scale, or frame not declared.",
        "Independent comparison missing, failed, or lacks residual bounds."
      ],
      "reviewChecklist": [
        "Confirm the source payload hashes are current for the run.",
        "Confirm the worker environment and input manifests are hash-backed.",
        "Run the command exactly as recorded or record the exact deviation.",
        "Validate the output artifact with the sidecar intake CLI.",
        "Do not update verified claims until the intake report is reviewed."
      ],
      "promotionBoundary": "This run spec is an execution contract only. It is not a scientific result, runtime artifact, or customer-facing proof.",
      "runSpecHash": "sha256-282d8d68479110e12375b4ee39ea99c50bc9b58767b28570ab5c3c5b7a92caa0"
    }
  ],
  "packetHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e"
}
;
